import { TtsLocale } from '../Base';
import { Stroke } from '../FileStore';

import { ConvertType } from './ConvertType';

export interface GameDraft {
  game: GameItemDraft;
  convertTypes: ConvertType[];
  locale: TtsLocale; // answer locale
}

interface TextDraftInterface {
  text: string;
  isRequired: boolean;
  minLength: number;
  maxLength: number;
  placeholder?: string;
  examples: string[];
  lengthByWord: boolean;
  soundText?: string;
  hasAutoTranslate?: boolean;
  missingStrokes: string[];

  strokeResolution?: Record<string, Stroke>;
}

export class TextDraft implements TextDraftInterface {
  text: string;
  isRequired: boolean;
  minLength: number;
  maxLength: number;
  placeholder?: string;
  examples: string[];
  lengthByWord: boolean;
  soundText?: string;
  hasAutoTranslate?: boolean;
  missingStrokes: string[];

  strokeResolution?: Record<string, Stroke>;

  constructor(
    text: string,
    isRequired: boolean,
    minLength: number,
    maxLength: number,
    examples: string[],
    lengthByWord: boolean,
    missingStrokes: string[],
    placeholder?: string,
    strokeResolution?: Record<string, Stroke>,
    soundText?: string,
    hasAutoTranslate?: boolean,
  ) {
    this.text = text;
    this.isRequired = isRequired;
    this.minLength = minLength;
    this.maxLength = maxLength;
    this.placeholder = placeholder;
    this.examples = examples;
    this.lengthByWord = lengthByWord;
    this.soundText = soundText;
    this.hasAutoTranslate = hasAutoTranslate;
    this.missingStrokes = missingStrokes;
    this.strokeResolution = strokeResolution;
  }

  get isEmpty() {
    return this.text.length === 0;
  }
}

// interface MediaInterface<T> {
//   medias: T[];
//   isRequired: boolean;
//   minItems: number;
//   maxItems: number;
// }

// class ImageDraft implements MediaInterface<string> {
//   medias: string[];
//   isRequired: boolean;
//   minItems: number;
//   maxItems: number;

//   constructor(
//     medias: string[],
//     isRequired: boolean,
//     minItems: number,
//     maxItems: number,
//   ) {
//     this.medias = medias;
//     this.isRequired = isRequired;
//     this.minItems = minItems;
//     this.maxItems = maxItems;
//   }

//   get isEmpty() {
//     return this.medias.length === 0;
//   }
// }

// class VideoDraft implements MediaInterface<string> {
//   medias: string[];
//   isRequired: boolean;
//   minItems: number;
//   maxItems: number;

//   constructor(
//     medias: string[],
//     isRequired: boolean,
//     minItems: number,
//     maxItems: number,
//   ) {
//     this.medias = medias;
//     this.isRequired = isRequired;
//     this.minItems = minItems;
//     this.maxItems = maxItems;
//   }

//   get isEmpty() {
//     return this.medias.length === 0;
//   }
// }

// class SoundDraft implements MediaInterface<string> {
//   medias: string[];
//   isRequired: boolean;
//   minItems: number;
//   maxItems: number;

//   constructor(
//     medias: string[],
//     isRequired: boolean,
//     minItems: number,
//     maxItems: number,
//   ) {
//     this.medias = medias;
//     this.isRequired = isRequired;
//     this.minItems = minItems;
//     this.maxItems = maxItems;
//   }

//   get isEmpty() {
//     return this.medias.length === 0;
//   }
// }

interface BasicComponentInterface {
  locale: TtsLocale;
  text: TextDraft;
  // image?: ImageDraft;
  // video?: VideoDraft;
  // sound?: SoundDraft;
  hasTts: boolean;
  isRequired: boolean;
}

export class BasicComponent implements BasicComponentInterface {
  locale: TtsLocale;
  text: TextDraft;
  // image?: ImageDraft;
  // video?: VideoDraft;
  // sound?: SoundDraft;
  hasTts: boolean;
  isRequired: boolean;

  constructor(
    locale: TtsLocale,
    text: TextDraft,
    // image: ImageDraft | undefined,
    // video: VideoDraft | undefined,
    // sound: SoundDraft | undefined,
    hasTts: boolean,
    isRequired: boolean,
  ) {
    this.locale = locale;
    this.text = text;
    // this.image = image;
    // this.video = video;
    // this.sound = sound;
    this.hasTts = hasTts;
    this.isRequired = isRequired;
  }

  // get isEmpty() {
  //   return (
  //     (this.text?.isEmpty ?? true) &&
  //     (this.image?.isEmpty ?? true) &&
  //     (this.video?.isEmpty ?? true) &&
  //     (this.sound?.isEmpty ?? true)
  //   );
  // }
}

export type GameItemDraft = {
  question: BasicComponent;
  answer: BasicComponent;
};
